import React from 'react';
import PropTypes from 'prop-types';
import ExtensionIcon from '@material-ui/icons/Extension';
import { sizes } from './CustomProviderLogo.variants';
import COLORS from '$variables/colors';

const CustomProviderLogo = ({ iconUrl, description, size }) => {
  const selectedSize = sizes[size];

  if (!iconUrl) {
    return (
      <ExtensionIcon
        data-testid="extension-icon"
        style={{
          width: selectedSize.width,
          height: selectedSize.height,
          color: COLORS.grey1,
        }}
      />
    );
  }

  return (
    <img
      width={selectedSize.width}
      height={selectedSize.height}
      src={iconUrl}
      alt={`${description} provider icon`}
    />
  );
};

CustomProviderLogo.propTypes = {
  iconUrl: PropTypes.string,
  description: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
};

CustomProviderLogo.defaultProps = {
  iconUrl: null,
  description: '',
  size: 'small',
};

export default CustomProviderLogo;
